export default __webpack_public_path__ + "static/media/delete-icon-golden.91358370.svg";